import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class HudView extends AbstractView {

    constructor(target, languagePack) {
        super(target);
        this._languagePack = languagePack;
        this._status;
        this._timeTextfield = this._target.timeTextfield;
        this._movesTextfield = this._target.movesTextfield;
        this._levelTextfield = this._target.levelTextfield;

        this._target.levelLabelTextfield.text = this.getText("hud.level.label");
        this._target.movesLabelTextfield.text = this.getText("hud.moves.label");
        this._target.timeLabelTextfield.text = this.getText("hud.time.label");
    }

    destroy() {
        super.destroy();
    }

    /**
     * @param {Number} value - elapsed time in msecs
     */
    setTime(value) {
        const decs = Math.floor((value % 1000) / 10);
        const secs = Math.floor(value / 1000) % 60;
        const mins = Math.floor(value / 60000) % 60;
        const hours = Math.floor(value / 3600000) % 24;
        let str = padTime(mins) + ":" + padTime(secs);// + "." + padTime(decs);
        if (hours > 0) {
            str = hours + ":" + str;
        }
        this._timeTextfield.text = str;
    }

    setMoves(n) {
        this._movesTextfield.text = n;
    }

    setLevel(idx, total) {
        let str = this.getText("hud.level", { CURRENT: idx, TOTAL: total });
        this._levelTextfield.text = str;
    }

}

HudView.START;

function padTime(str) {
    return ("0" + str).substr(-2);
}